import { Stack, Typography } from '@mui/material';
import { Gauge, gaugeClasses } from '@mui/x-charts';

import { error, success, warning } from '../../theme/colors';

interface ITaskSuccessRateProps {
  successRate: number;
}

export const TaskSuccessRate = ({ successRate }: ITaskSuccessRateProps) => {
  const color = successRate < 50 ? error : successRate <= 75 ? warning : success;
  return (
    <Stack
      overflow="auto"
      maxWidth="100%"
      sx={{
        borderRadius: '20px',
        marginTop: '16px',
        background: color.lightest,
        width: '100%',
        height: 'fit-content',
      }}
    >
      <Stack
        pt={4}
        pb={8}
        px={3}
      >
        <Typography variant="h6">Task Success Rate</Typography>
        <Typography
          variant="body1"
          sx={{
            marginTop: '8px',
          }}
        >
          This metric reflects backend stability and task logic accuracy
        </Typography>

        <Stack
          alignItems="center"
          mt={5}
        >
          <Gauge
            width={160}
            height={95}
            value={successRate}
            startAngle={-90}
            endAngle={90}
            cornerRadius="50%"
            sx={{
              [`& .${gaugeClasses.valueText}`]: {
                fontSize: 24,
                transform: 'translate(0px, -15px)',
                fontWeight: 600,
                fontFamily: 'Inter, sans-serif',
              },
              [`& .${gaugeClasses.valueArc}`]: {
                fill: color.main,
              },
              [`& .${gaugeClasses.valueText} text`]: {
                fill: color.main,
              },
            }}
            text={({ value }) => `${value}%`}
          />
          <Typography variant="h6">All tasks completed without errors </Typography>
          <Typography
            variant="body1"
            sx={{
              marginTop: '8px',
            }}
          >
            A drop below 95% may indicate issues with workflows or UX friction.
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
